import { createPinia } from 'pinia';

// 共享的 pinia 实例：主 app 与 H5 全局弹窗 app 复用同一份，确保 store 单例一致
export const pinia = createPinia();
